module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S3.48d9302c.png";